import { idtype } from "querypieces";

export default `
...on pageBuilder_heading_BlockType {
	${idtype}
	heading
	colors
}
`